import { FC } from "react";
import { useTheme, Theme } from "@emotion/react";
import { GoodOnYouInfo } from "src/molecules/GoodOnYou/types";
import { StyledDivider } from "src/molecules/GoodOnYou/GoodOnYou.styled";
import GoodOnYouPillars from "./GoodOnYouPillars";
import GoodOnYouRating from "./GoodOnYouRating";
import GoodOnYouCertifications from "./GoodOnYouCertifications";

interface Props {
  info: GoodOnYouInfo;
  brandName: string;
}

const GoodOnYou: FC<Props> = ({ info, brandName }) => {
  const theme: Theme = useTheme();

  return (
    <>
      <StyledDivider color={theme.colors.tone.marble} />
      <GoodOnYouRating
        scoreMeta={info.score_meta}
        overallScore={info.scores.overall}
        pageType="brandsPage"
        brandName={brandName}
      />
      <GoodOnYouPillars pillars={info.pillars} scores={info.scores} />
      {info.certifications && info.certifications.length > 0 && (
        <>
          <StyledDivider color={theme.colors.tone.marble} />
          <GoodOnYouCertifications certifications={info.certifications} />
        </>
      )}
    </>
  );
};

export default GoodOnYou;
